import React from 'react';
import { Accordion } from 'react-bootstrap';
import Navigation from '../../components/navigation';
import Footer from '../../components/footer';
import ResponsiveMenu from '../../components/responsive-navigation';
import User1 from '../../images/user-1.jpg';
import User2 from '../../images/user-2.jpg';
import User3 from '../../images/user-3.jpg';
import User4 from '../../images/user-4.jpg';
import User5 from '../../images/user-5.jpg';
import BannerImage from '../../images/banner-img.png';
import LogosImages from '../../images/logos.png';
import EarnMoney from '../../images/earn-money.png';
import CreatorImg from '../../images/creator-01.png';
import CreatorImg2 from '../../images/creator-02.png';
import FeatIcon01 from '../../images/feat-icon01.png';
import FeatIcon02 from '../../images/feat-icon02.png';
import FeatIcon03 from '../../images/feat-icon03.png';
import FeatIcon04 from '../../images/feat-icon04.png';
import FeatIcon05 from '../../images/feat-icon05.png';
import FeatIcon06 from '../../images/feat-icon06.png';
import OpenaiImg from '../../images/open-ai.png';

const LandingHome = ({ navigation, currentUser }) => {
    const isAuthenticated = !!currentUser;
    const handleSignUp = (event) => {
        event.preventDefault();
        if (navigation && typeof navigation.signUp === 'function') {
            navigation.signUp();
        }
    };

    const handleSignIn = (event) => {
        event.preventDefault();
        if (navigation && typeof navigation.signIn === 'function') {
            navigation.signIn();
        }
    };

    const handleFaq = (event) => {
        event.preventDefault();
        if (navigation && typeof navigation.faq === 'function') {
            navigation.faq();
        }
    };

    const handleLearnMore = (event) => {
        event.preventDefault();
        if (navigation && typeof navigation.featuredPackages === 'function') {
            navigation.featuredPackages();
        }
    };

    return (
        <div>
            <header>
                <div className="nav-container">
                    <div className="container">
                        <Navigation isAuthenticated={isAuthenticated} currentUser={currentUser} navigation={navigation} />
                    </div>
                </div>
            </header>
            <section className="banner-section common-bg">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="site-heading">
                                <div className="user-images">
                                    <img src={User1} alt="Creator" />
                                    <img src={User2} alt="Creator" />
                                    <img src={User3} alt="Creator" />
                                    <img src={User4} alt="Creator" />
                                    <img src={User5} alt="Creator" />
                                </div>
                                <h6>
                                    Trusted by <strong>Top Creators</strong>
                                    <br />
                                    OpenSwap is a <span>Digital Assets Marketplace</span>
                                </h6>
                                <h1>
                                    <span className="clr-primary">The</span>
                                    CREATOR'S PLATFORM
                                </h1>
                                <p className="clr-white">Sell Music, Photography, Videography and More!</p>
                                <div className="d-flex align-items-center">
                                    <a href="/signup" className="site-btn" onClick={handleSignUp}>
                                        Become a Creator
                                    </a>
                                    <a href="/signup" className="site-btn-2" onClick={handleSignUp}>
                                        Sign up as a Fan
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="banner-img">
                                <img className="image_animate" src={BannerImage} alt="Creator hero" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="logos-section">
                <div className="container">
                    <div className="site-heading text-center">
                        <h2 className="text-uppercase">Featured In</h2>
                    </div>
                    <div className="logos-images">
                        <img src={LogosImages} alt="Press logos" />
                    </div>
                </div>
            </section>
            <section className="earn-money-section common-bg">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="earn-money-image">
                                <img className="image_animate" src={EarnMoney} alt="Earn money" />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="earn-money-text">
                                <div className="earn-subscription"><span role="img" aria-label="money with wings">💸</span> Subscription</div>
                                <div className="site-heading">
                                    <h2 className="clr-white text-uppercase">
                                        Earn money <br />
                                        from <span className="clr-primary text-capitalize">Subscriptions</span>
                                    </h2>
                                    <p className="clr-white">
                                        Put your exclusive content behind a paywall for your top fans to subscribe to, generating you recurring revenue.
                                    </p>
                                    <a href="/signup" className="site-btn" onClick={handleSignUp}>
                                        Become a Creator
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="signup-section">
                <div className="container">
                    <div className="site-heading text-center">
                        <h2>
                            Sign up this Month, <span>Earn More</span>
                        </h2>
                        <p>Join the fastest growing platform in the creator economy and earn 85%</p>
                        <a href="/signup" className="site-btn" onClick={handleSignUp}>
                            Become a Creator
                        </a>
                    </div>
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="signup-box common-bg">
                                <img src={CreatorImg} alt="Join a platform that cares" />
                                <div className="site-heading">
                                    <h2 className="clr-white text-uppercase">
                                        Join a platform <br />
                                        that <span className="clr-primary text-capitalize">Cares</span>
                                    </h2>
                                    <p className="clr-white">
                                        We're the fastest growing platform in the creator economy because we care about all creators.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="signup-box common-bg">
                                <img src={CreatorImg2} alt="Simple and easy to get started" />
                                <div className="site-heading">
                                    <h2 className="clr-white text-uppercase">
                                        Simple &amp; easy to <br />
                                        get <span className="clr-primary text-capitalize">Started</span>
                                    </h2>
                                    <p className="clr-white">Become a verified creator ready to start earning in less than 3 minutes.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="featured-section common-bg">
                <div className="container">
                    <div className="site-heading">
                        <h2 className="clr-white text-uppercase">
                            All the features you need to <span className="text-capitalize">Succeed</span>
                        </h2>
                    </div>
                    <div className="row">
                        <div className="col-lg-4 col-md-6 col-sm-12">
                            <div className="feature-item">
                                <img src={FeatIcon01} alt="AI features" />
                                <h4>AI Features</h4>
                                <p>The only platform with AI messaging, voice notes and analytics all in one place. Coming soon.</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12">
                            <div className="feature-item">
                                <img src={FeatIcon02} alt="Smart messaging" />
                                <h4>Smart Messaging</h4>
                                <p>Use custom list filters, automated messages and mass messaging to increase your earnings.</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12">
                            <div className="feature-item">
                                <img src={FeatIcon03} alt="Subscriptions" />
                                <h4>Subscriptions</h4>
                                <p>Enable your top fans to subscribe to access your content. Offer trials, discounts and more!</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12">
                            <div className="feature-item">
                                <img src={FeatIcon04} alt="24/7 support" />
                                <h4>24/7 Support</h4>
                                <p>We know how frustrating it can be when you can't get support. We're available 24/7 for anything you need.</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12">
                            <div className="feature-item">
                                <img src={FeatIcon05} alt="Advanced insights" />
                                <h4>Advanced Insights</h4>
                                <p>Use our advanced insights &amp; analytics to understand how you can improve your earnings.</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12">
                            <div className="feature-item">
                                <img src={FeatIcon06} alt="Pay-to-view" />
                                <h4>Pay-to-View</h4>
                                <p>Sell content behind a paywall, on your profile, in your content vault, or via messages.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="openai-section">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="site-heading">
                                <h2>
                                    OPENSWAP <strong className="clr-primary">AI</strong>
                                </h2>
                                <p>The only subscription platform that combines AI messaging, voice notes and analytics all in one place.</p>
                                <a href="/featured/packages" className="site-btn" onClick={handleLearnMore}>
                                    Find Out More
                                </a>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="openai-img">
                                <img className="image_animate" src={OpenaiImg} alt="OpenSwap AI" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="question-section common-bg">
                <div className="container">
                    <div className="site-heading">
                        <h2 className="clr-white text-uppercase">Frequently asked questions</h2>
                    </div>
                    <div className="faqs-wrapper-list">
                        <Accordion>
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>What is OpenSwap?</Accordion.Header>
                                <Accordion.Body>
                                    OpenSwap is a digital assets marketplace that helps creators monetize exclusive content through subscriptions, pay-to-view drops, and premium fan experiences.
                                </Accordion.Body>
                            </Accordion.Item>

                            <Accordion.Item eventKey="1">
                                <Accordion.Header>Who can create on OpenSwap?</Accordion.Header>
                                <Accordion.Body>
                                    Any approved creator with original content can launch on OpenSwap. We support artists, musicians, videographers, photographers, and emerging AI creators.
                                </Accordion.Body>
                            </Accordion.Item>

                            <Accordion.Item eventKey="2">
                                <Accordion.Header>How much can I make on OpenSwap?</Accordion.Header>
                                <Accordion.Body>
                                    Creators take home up to 85% of their earnings, keeping more of every subscription, tip, and pay-to-view sale.
                                </Accordion.Body>
                            </Accordion.Item>

                            <Accordion.Item eventKey="3">
                                <Accordion.Header>How long does it take to become a creator?</Accordion.Header>
                                <Accordion.Body>
                                    The onboarding flow takes just a few minutes. Submit your profile, verify your identity, and start publishing as soon as you're approved.
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </div>
                    <div className="faq-cta-row mt-4">
                        <a href="/faq" className="site-btn" onClick={handleFaq}>
                            Visit the Help Center
                        </a>
                        <a href="/signin" className="site-btn-2" onClick={handleSignIn}>
                            Contact Support
                        </a>
                    </div>
                </div>
            </section>
            <Footer />
            <ResponsiveMenu isAuthenticated={isAuthenticated} currentUser={currentUser} navigation={navigation} />
        </div>
    );
};

export default LandingHome;
